import React, { useState } from 'react';
import Sidebar from '../partials/Sidebar';
import Header from '../partials/Header';
import DashboardCard10 from '../partials/dashboard/DashboardCard10';

function Users() {

    const [sidebarOpen, setSidebarOpen] = useState(false);

    return (
        // <div className="flex h-screen overflow-hidden">

        //     <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
        //     <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
        //         <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
        //         <main className="flex  min-h-screen">
        //             <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
        //                 <div className="justify-center items-center">
        //                         <DashboardCard10 />
        //                 </div>
        //             </div>
        //         </main>                
        //     </div>
        // </div>

        <div className="flex h-screen //overflow-auto pb-safe-bottom pt-safe-top">
        <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
        <div className="relative flex flex-col min-h-screen-mobile flex-1 overflow-y-auto overflow-x-hidden min-h-0">
            <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
            <main className="flex flex-col flex-1 min-h-0">
                <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl xs:max-w-screen-xl mx-auto max-w-md md:max-w-2xl">
                    <div className="flex justify-center items-center xs:pb-10">
                        <DashboardCard10 />
                    </div>
                </div>
            </main>
        </div>
    </div>
    );
}

export default Users;